
const digest = '54ae23abb72c5ad9f2d1759a44eff03d862ffe596e04688cda10023a933e65c5';
const css = `._test_wpbpe_1 {
    border: 1px solid red;
    padding: 25px;
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"test":"_test_wpbpe_1"};
export { css, digest };
  